export default {
  Auth: { 
    region: 'us-east-1',
    userPoolId: 'us-east-1_IkI5xqydL',
    userPoolWebClientId: '2jjsthc42aknolqhafkd6grs00',
  }
}

export const EXTERNAL_API_URL_BASE = "https://api.siftrdev.com/";
